import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  tabs: {
    padding: '3.5rem 0 0 3.5rem'
  },

  subTabs: {
    marginBottom: '-2rem',
    padding: '0.5rem 0 0 3.5rem'
  },

  tab: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
